
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["uqdzed",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M28.486 59.97c-6.636-.57-11.563-2.328-16.322-5.825C4.444 48.472 0 39.647 0 29.987 0 15.112 10.507 2.798 25.274.367c6.029-.992 12.704.05 18.288 2.854 13.577 6.818 19.782 22.54 14.643 37.103-3.528 9.998-12.79 17.618-23.391 19.245-2.086.32-5.065.509-6.328.4z","fill":"#3f82dc"}}),_c('path',{attrs:{"d":"M41 19H19c-1.74 0-2.986 1.238-3 3v16c0 1.762 1.26 3 3 3h22c1.74 0 3-1.238 3-3V22c0-1.762-1.26-3-3-3zm0 6l-11 7-11-7v-3l11 7 11-7v3z","fill":"#FFF"}})])])
          )
        }
      }
    